import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { fileTypes } from '../../_constants/files';
import UploadHandler from '../../UploadHandler';

var Files = function Files(_ref) {
  var fileMap = _ref.fileMap,
      fileState = _ref.fileState,
      onFileUpload = _ref.onFileUpload,
      onFileDelete = _ref.onFileDelete;
  return React.createElement(Fragment, null, React.createElement('label', {
    className: 'mbot-20'
  }, 'Tax registration form*'), React.createElement('div', {
    className: 'form-group'
  }, React.createElement(UploadHandler, {
    type: fileTypes.TAX_REGISTRATION_FORM,
    files: fileMap,
    fileState: fileState,
    onFileUpload: onFileUpload,
    onFileDelete: onFileDelete,
    message: React.createElement('div', {
      className: 'mtop-20'
    }, "Please upload your most recent Constancia de Situaci\xF3n Fiscal (Proof of Fiscal Situation document) provided by Mexico\u2019s Servicio de Administraci\xF3n Tributaria (Tax Administration Service)")
  })), React.createElement('label', {
    className: 'mbot-20'
  }, 'Balance sheet (most recent year)'), React.createElement('div', {
    className: 'form-group'
  }, React.createElement(UploadHandler, {
    files: fileMap,
    fileState: fileState,
    type: fileTypes.LAST_BALANCE,
    onFileUpload: onFileUpload,
    onFileDelete: onFileDelete
  })));
};

Files.propTypes = {
  fileMap: PropTypes.object.isRequired,
  fileState: PropTypes.object.isRequired,
  onFileUpload: PropTypes.func.isRequired,
  onFileDelete: PropTypes.func.isRequired
};
export default Files;